export function successStartEventText(message: string): string {
  if (message.includes('Process proses_pengajuan_cuti_ciomystarted')) {
    return 'Process Pengajuan Cuti started'
  }

  return message
}
